import { Link, useLocation } from "wouter";
import { Home, List, Package, Settings } from "lucide-react";

// Single unified UI — one nav for everyone (Normal mode removed).
const navItems = [
  { path: "/dashboard", icon: Home, label: "Dashboard" },
  { path: "/transactions", icon: List, label: "Transactions" },
  { path: "/products", icon: Package, label: "Products" },
  { path: "/settings", icon: Settings, label: "Settings" },
];

export function BottomNav() {
  const [location] = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center justify-around py-2">
        {navItems.map((item) => {
          const isActive =
            location === item.path ||
            (item.path === "/" && location === "/home") ||
            (item.path === "/dashboard" && location === "/");
          return (
            <Link key={item.path} href={item.path}>
              <button
                className={`flex flex-col items-center justify-center min-w-[64px] min-h-[48px] gap-1 transition-colors ${isActive ? "text-primary" : "text-muted-foreground"
                  }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <item.icon className="h-5 w-5" />
                <span className="text-xs font-medium">{item.label}</span>
              </button>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
